#firewall-settings-info-text {
  color: var(--body-text-arrows-400);
}

#firewall-exclusions-content-text {
  margin-bottom: calc(var(--spacer) * -3); // remove extra space added by grid
}

.form-field-info-text {
  padding-top: calc(var(--spacer));
}

.pl-0 {
  padding-left: 0px;
}
